/* eslint-disable max-len */
import path from 'path';

export const apiBaseURL = '//local.rakuten.co.jp';
export const apiCheckURL = '//api.oubo.rakuten.co.jp/1.0/entry/check?n=';
export const apiApplyURL = '//api.oubo.rakuten.co.jp/1.0/entry/apply?i=';
export const makeLoginRedirectURL = cCode => `//oubo.rakuten.co.jp/${path.join('apply/', cCode)}`;

export const REDIRECTION_DELAY_AFTER_SUCCESS = 2500;
export const REDIRECTION_DELAY_AFTER_IN_PROCESS = 1500;

export const buttonStateMap = {
  ENABLED: 'ENABLED',
  ALREADY_APPLIED: 'ALREADY_APPLIED',
  EXPIRED: 'EXPIRED',
  LOGIN: 'LOGIN',
  LOADING: 'LOADING',
  IN_PROCESS: 'IN_PROCESS',
  SUCCESS: 'SUCCESS',
  RETRY: 'RETRY',
  TOC_NOT_CHECKED: 'TOC_NOT_CHECKED',
};

export const buttonStateText = {
  ENABLED: 'エントリーはこちら',
  ALREADY_APPLIED: '本キャンペーンにエントリー済みです。',
  EXPIRED: 'このキャンペーンは終了しました。',
  LOGIN: 'ログインする',
  LOADING: '',
  IN_PROCESS: 'へ移動します',
  SUCCESS: 'エントリーが完了しました',
  RETRY: 'エントリーはこちら',
  TOC_NOT_CHECKED: 'エントリーはこちら',
};

export const validationTextMap = {
  DEVICE_NOT_ALLOWED: 'お使いのデバイスではエントリーできません。',
  NOT_LOGGED_IN: 'キャンペーンにエントリーするにはログインが必要です。',
  LOGIN_ISSUE: '不具合が発生しました。再度ログインしてください。',
  FALLBACK: 'エラーが発生しました。後でお試しください。',
  MAINTENANCE: 'ただいまメンテナンス中です。ご迷惑おかけ致しますが、しばらく経ってから今一度エントリーをお願いします。',
  CAMPAIGN_NOT_FOUND: 'Campaign not found.',
};

export const theme = {
  RED: 'red',
  BLUE: 'blue',
  DARK_BLUE: 'dark-blue',
  YELLOW: 'yellow',
  GREEN: 'green',
  PURPLE: 'purple',
  PINK: 'pink',
};

export const themeColorCode = {
  [theme.RED]: '#bf0000',
  [theme.BLUE]: '#00a0f0',
  [theme.DARK_BLUE]: '#002896',
  [theme.YELLOW]: '#ffa000',
  [theme.GREEN]: '#4bcd00',
  [theme.PURPLE]: '#7d00be',
  [theme.PINK]: '#ff41be',
};



// WEBPACK FOOTER //
// ./src/constant.js